import { render } from "./FacetFilter.vue?vue&type=template&id=5ac9be38&scoped=true"
import script from "./FacetFilter.vue?vue&type=script&lang=js"
export * from "./FacetFilter.vue?vue&type=script&lang=js"

import "./FacetFilter.vue?vue&type=style&index=0&id=5ac9be38&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ac9be38"]])

export default __exports__